import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { change, Field, reduxForm } from 'redux-form';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import MDSwitchView from '../Fields/MDSwitch/MDSwitchView.jsx';
import SentenceSelectorInputField from '../Fields/SentenceSelectorInputField.jsx';
import CustomField from '../Fields/CustomField.jsx';
import TranslatableOption from '../Fields/TranslatableOption.jsx';
import OfficeModeIconCustom from '../../CustomIcons/OfficeModeIconCustom.jsx';
import CogIconCustom from '../../CustomIcons/CogIconCustom.jsx';
import { Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import WarningIcon from '@material-ui/icons/Warning';
import InfoSection from '../../InfoSection/InfoSection.jsx';


const validate = values => {
  const errors = {};

  if (values.fourEyesPeriod && (Number(values.fourEyesPeriod) === 0 || Number(values.fourEyesPeriod) > 60)) {
    errors.fourEyesPeriod = 'maxValue60Seconds';
  }
  if (values.inhibitTime && (Number(values.inhibitTime) === 0 || Number(values.inhibitTime) > 65535)) {
    errors.inhibitTime = 'maxInhibitTimeValue';
  }
  if (values.openingTime && (Number(values.openingTime) < 0 || Number(values.openingTime) > 255)) {
    errors.openingTime = 'maxOpeningTimeValue';
  }
  return errors;
};

/*

 protected Short openingTime;
  protected ValidationMode validationMode;
  protected Integer minValidationPeriod;
  protected Boolean alwaysOpenEnabled;
  protected Short alwaysOpenTimeProfileId;
  protected Short keyAlwaysOpenTimeProfileId;
  protected Boolean logDisabled;
  protected Integer inhibitTime;
  protected Boolean pinCredentials;
  protected ValidationMode fourEyesMode;
  protected Short fourEyesPeriod;

*/

@reduxForm({ form: 'LockV364ConfigurationsForm', validate })
@connect(state => ({ form: state.form.LockV364ConfigurationsForm }))
class LockV364ConfigurationsForm extends React.Component {
  onToggleShowInhibitTime(selected) {
    const { dispatch, form } = this.props;
    if (!selected) {
      dispatch(change('LockV364ConfigurationsForm', 'inhibitTime', 0));
    } else {
      dispatch(change('LockV364ConfigurationsForm', 'inhibitTime', 10));
    }
  }

  onToggleFourEyes(selected) {
    const { dispatch } = this.props;
    if (!selected) {
      dispatch(change('LockV364ConfigurationsForm', 'fourEyesMode', false));
      dispatch(change('LockV364ConfigurationsForm', 'fourEyesPeriod', 0));
    } else {
      dispatch(change('LockV364ConfigurationsForm', 'fourEyesMode', true));
      dispatch(change('LockV364ConfigurationsForm', 'fourEyesPeriod', 10));
    }
  }

  onSelectTimeProfile(value) {
    const { dispatch } = this.props;
    if (value !== '0') {
      dispatch(change('LockV364ConfigurationsForm', 'alwaysOpenEnabled', true));
    } else {
      dispatch(change('LockV364ConfigurationsForm', 'alwaysOpenEnabled', false));
    }
  }

  render() {
    const { timeProfiles, showOfflineConfigurationWarning = true, form } = this.props;
    const timeProfilesOptions = [
      {
        entity: 'selectTimeProfile',
        value: 0,
      },
      ..._.map(timeProfiles, timeProfile =>
        ({
          entity: timeProfile.name,
          value: timeProfile.id,
        })
      )
    ];
    return (
      <Form>
        <FormFlatContainer
          title="passageModeConfigurations"
          icon={<OfficeModeIconCustom style={{ width: 20 }} /> }
          headerStyle={{ marginBottom: 0 }}
          containerStyle={{ marginRight: 5 }}
        >
          <div style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}>
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}><Entity entity="automaticPassageMode" /></h4>
            <h4 style={{ color: '#3f3f3f', fontSize: 16, marginBottom: 15 }}><Entity entity="automaticPassageModeDescription" /></h4>
            <Field
              id="alwaysOpenTimeProfileId"
              name="alwaysOpenTimeProfileId"
              component={CustomField}
              containerStyle={{ marginLeft: 0 }}
              className="form-control-select"
              componentClass="select"
              onHandleChange={(value) => this.onSelectTimeProfile(value)}
            >
              {_.map(timeProfilesOptions, type =>
                <Entity
                  key={type.value}
                  componentClass={TranslatableOption}
                  value={type.value}
                  componentAttribute="text"
                  entity={type.entity}
                />)}
            </Field>
          </div>
          <Divider />
          <div style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}>
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}><Entity entity="passageModeWithCredentialAutorelock" /></h4>
            <h4 style={{ color: '#3f3f3f', fontSize: 16, marginBottom: 15 }}><Entity entity="passageModeWithCredentialAutorelockDescription" /></h4>
            <Field
              id="keyAlwaysOpenTimeProfileId"
              name="keyAlwaysOpenTimeProfileId"
              component={CustomField}
              containerStyle={{ marginLeft: 0 }}
              className="form-control-select"
              componentClass="select"
            >
              {_.map(timeProfilesOptions, type =>
                <Entity
                  key={type.value}
                  componentClass={TranslatableOption}
                  value={type.value}
                  componentAttribute="text"
                  entity={type.entity}
                />)}
            </Field>
          </div>
        </FormFlatContainer>
        <FormFlatContainer
          title="smartLockConfigurationsDescription"
          icon={<CogIconCustom style={{ width: 20 }} /> }
          headerStyle={{ marginBottom: 0 }}
          containerStyle={{ marginBottom: showOfflineConfigurationWarning ? 0 : 150, marginRight: 5 }}
        >
          <div style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}>
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}><Entity entity="openingTime" /></h4>
            <h4 style={{ color: '#3f3f3f', fontSize: 16, marginBottom: 15 }}><Entity entity="openingTimeDescription" /></h4>
            <Field
              id="openingTime"
              name="openingTime"
              component={CustomField}
              containerStyle={{ marginLeft: 0 }}
              className="form-control-select"
              type="number"
            />
          </div>
          <Divider />
          <div style={{ paddingLeft: 15, marginTop: 10 }}>
            <MDSwitchView
              label={<Entity key={form?.values?.inhibitTime} entity="checkBackInhibitTime" />}
              checked={form?.values?.inhibitTime}
              titleStyle={{ fontWeight: form?.values?.inhibitTime ? 'bold' : 'normal', color: '#3f3f3f', fontSize: 17, marginBottom: 1 }}
              onSelect={selected => this.onToggleShowInhibitTime(selected)}
            />
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 45, marginTop: -10 }}>
                <Entity
                  id="inhibitTime"
                  name="inhibitTime"
                  componentClass={Field}
                  componentAttribute="sentence"
                  component={SentenceSelectorInputField}
                  unit="seconds"
                  disabled={!form?.values?.inhibitTime}
                  titleStyle={{ fontSize: 16 }}
                  entity="checkBackInhibitTimeDescription"
                />
              </div>
          </div>
          <div style={{ paddingLeft: 15, marginTop: 15 }}>
            <MDSwitchView
              label={<Entity key={form?.values?.fourEyesMode} entity="fourEyesPrinciple" />}
              checked={form?.values?.fourEyesMode}
              titleStyle={{ fontWeight: form?.values?.fourEyesMode ? 'bold' : 'normal', color: '#3f3f3f', fontSize: 17, marginBottom: 1 }}
              onSelect={selected => this.onToggleFourEyes(selected)}
            />
              <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 45, marginTop: -10 }}>
                <Entity
                  id="fourEyesPeriod"
                  name="fourEyesPeriod"
                  componentClass={Field}
                  componentAttribute="sentence"
                  component={SentenceSelectorInputField}
                  titleStyle={{ fontSize: 16 }}
                  disabled={!form?.values?.fourEyesMode}
                  unit="seconds"
                  entity="fourEyesPrincipleDescription"
                />
                </div>
          </div>
          <div style={{ paddingLeft: 25, marginTop: 10, paddingRight: 25, }}>
            <Field
              name="logDisabled"
              label={<Entity entity="logDisabled" />}
              titleStyle={{ fontSize: 17, fontWeight: 'bold', color: '#3f3f3f' }}
              containerstyle={{ marginTop: 0 }}
              component={MDCheckBoxField}
            />
            <h4 style={{ marginTop: -10, lineHeight: 1.5, marginLeft: 35, fontSize: 15, color: '#3f3f3f', fontWeight: 'light' }}><Entity entity="logDisabledDescription" /></h4>
          </div>
        </FormFlatContainer>
        {showOfflineConfigurationWarning ? (
          <InfoSection
            title="offlineConfigurationWarning"
            gravity="warning"
            titleStyle={{ fontWeight: 'normal' }}
            containerStyle={{ marginTop: 20, marginBottom: 200 }}
          />
        ) : null}
      </Form>
    );
  }
} 

export default LockV364ConfigurationsForm;
